import { render, staticRenderFns } from "./SearchCoin2.vue?vue&type=template&id=2e63ea82&"
import script from "./SearchCoin2.vue?vue&type=script&lang=js&"
export * from "./SearchCoin2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports